var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsHitzewallung(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 -1 15 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-hitzewallung") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "trends-hot-flame",
    stroke: "#7F8BDB",
    transform: "translate(-0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13616413,0.0578356769 C5.94345498,-0.0438885969 5.7070582,-0.00909228614 5.55183397,0.143845874 C5.39660974,0.296784034 5.35831008,0.532638562 5.45716413,0.726835677 C7.27216413,4.27383568 7.07916413,9.13283568 4.59416413,11.8738357 C3.83847688,11.0123185 3.32135262,9.96807226 3.09416413,8.84483568 C-2.80583587,13.0698357 0.305164127,22.3448364 7.59416413,22.3448364 C18.0641641,22.3488357 16.6671641,5.63883568 6.13616413,0.0578356769 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09416413,13.3488357 C9.08416413,15.1118357 6.58216413,17.6428357 5.09416413,17.2928357 C5.30630929,18.4820301 6.3401953,19.3482362 7.54816413,19.3488357 C11.1721641,19.3488357 10.7771641,14.3488357 8.09416413,13.3488357 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHitzewallung);
export default __webpack_public_path__ + "static/media/icons-hitzewallung.02aaa0b076813100afaa75a69a9c94fe.svg";
export { ForwardRef as ReactComponent };